import { VoiceConfig } from '@d-id/types';

export function getSsml(text: string, voiceId: string, voiceConfig?: VoiceConfig) {
    const escapedText = escapeSsmlText(text);
    return `
<speak xmlns="http://www.w3.org/2001/10/synthesis" xmlns:mstts="http://www.w3.org/2001/mstts" xmlns:emo="http://www.w3.org/2009/10/emotionml" version="1.0" xml:lang="en-US">
    <voice name="${voiceId}">${
        voiceConfig?.style
            ? `
        <mstts:express-as style="${voiceConfig.style}">`
            : ''
    }
        <prosody rate="${voiceConfig?.rate ?? '0%'}" pitch="${voiceConfig?.pitch ?? '0%'}" volume="${
            voiceConfig?.volume ?? 100
        }">
            ${escapedText}
        </prosody>${
            voiceConfig?.style
                ? `
        </mstts:express-as>`
                : ''
        }
    </voice>
</speak>`;
}

export function escapeSsmlText(text: string, breakOnly = false, isV3Model = false): string {
    if (isV3Model) {
        return text;
    }

    const escapeCharacters: Record<string, string> = {
        '⏱': '<break time="0.5s" />',
    };

    if (!breakOnly) {
        escapeCharacters['&'] = '&amp;';
        escapeCharacters['<'] = '&lt;';
        escapeCharacters['>'] = '&gt;';
        escapeCharacters['"'] = '&quot;';
        escapeCharacters["'"] = '&#39;';
    }

    const escapedText: string = text.replace(
        new RegExp(`${Object.keys(escapeCharacters).join('|')}`, 'g'),
        match => escapeCharacters[match]
    );
    return escapedText;
}

export function unescapeSsmlText(text: string, includeBreak = true): string {
    const escapeCharacters: Record<string, string> = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'",
    };

    if (includeBreak) {
        escapeCharacters['<break time="0.5s" />'] = '⏱';
    }

    const escapedText: string = text.replace(
        new RegExp(`${Object.keys(escapeCharacters).join('|')}`, 'g'),
        match => escapeCharacters[match]
    );

    return escapedText;
}
